import TextAlign from '@tiptap/extension-text-align';

export default TextAlign.configure({
  types: ['heading', 'paragraph'],
});
